import FirebaseHandler from "./index";
import { httpsCallable } from "firebase/functions";
export const subscribeToNewsletter = email => {
    const subscribeNewsletter = httpsCallable(FirebaseHandler.functions, "subscribeNewsletter");
    return subscribeNewsletter({
        email: email
    });
};
